import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'APIC Dev Portal';

  isProduction: boolean;
  environment: string;
  constructor() {
    this.environment = environment.getEnvironment();
    this.isProduction = environment.production;
  }  

}
